module.exports = __webpack_public_path__ + "media/images/settings-937b99296c03c3f062693cecc6833df8.svg";